import {Colors} from "../Constants/Colors";
import {LoadingOverlay} from "@mantine/core";
import React from "react";

const PageLoading = ({visible}) =>{
    return <LoadingOverlay
        visible={visible}
        loaderProps={{ size: 'sm', color: Colors.Primary, variant: 'bars' }}
        sx={{width: '85%',height: '90%'}}
        ml={200}
        mt={50}
    />
}
export default PageLoading;
